var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNormalMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-209 -277) translate(55 249) translate(0 .245) translate(154 28.755)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.58,
    cy: 14.58,
    r: 14.58,
    fill: "#2E844F"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.109 0h-9.72C.625 0 0 .729 0 1.62v11.34c0 .891.625 1.62 1.389 1.62h9.72c.763 0 1.388-.729 1.388-1.62V1.62c0-.891-.625-1.62-1.388-1.62zM2.836 4.695v-1.62h4.86v1.62h-4.86zm0 3.24v-1.62h6.943v1.62H2.836zm0 3.24v-1.62h2.777v1.62H2.836z",
    transform: "translate(7.637 7.72) translate(.198) translate(.496)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalMessage);
export default __webpack_public_path__ + "static/media/NormalMessage.5382b16365d7b402e76c1fed172da2f2.svg";
export { ForwardRef as ReactComponent };